// Image URL helper for this project's assets. Every asset of the project is
// served on the site's own origin as /_assets/<file>, and Cloudflare resizes
// it on the fly via /cdn-cgi/image/<options>/_assets/<file>.
//
// Accepts, and normalises to the same-origin form:
//   - "/_assets/hero.png"                                   (already right)
//   - "https://assets.auxodev.dk/assets/<id>/hero.png"      (CDN URL from the tools / CMS)
//   - "/assets/<id>/hero.png"                               (CDN path without host)
//   - "hero.png"                                            (a bare file name — only this
//                                                            project's assets can be meant)
// Foreign URLs (other hosts, data: URIs, paths into /images or /public) pass
// through untouched and are never resized.

const CDN = /^https?:\/\/assets\.auxodev\.dk\/assets\/[^/]+\//;
const BARE_FILE = /^[^/\\?#:]+\.(png|jpe?g|webp|gif|avif|svg|mp4|webm|mov|pdf|woff2?)$/i;

export const assetPath = (u) => {
  const s = String(u || '').trim();
  if (!s) return '';
  if (s.startsWith('/_assets/')) return s;
  if (CDN.test(s)) return '/_assets/' + s.replace(CDN, '');
  const m = s.match(/^\/?assets\/[^/]+\/(.+)$/);
  if (m) return '/_assets/' + m[1];
  if (BARE_FILE.test(s)) return '/_assets/' + s;
  return s;
};

export const imageUrl = (u, opts = 'width=800,quality=80,format=auto') => {
  const p = assetPath(u);
  if (!p.startsWith('/_assets/') || p.includes('/cdn-cgi/image/')) return p;
  return '/cdn-cgi/image/' + opts + p;
};

export const srcSet = (u, widths = [400, 800, 1200]) =>
  widths.map((w) => imageUrl(u, 'width=' + w + ',quality=80,format=auto') + ' ' + w + 'w').join(', ');
